// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.role-guard-container {
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  textAlign: center;
}

.role-guard-card {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 16px;
  padding: 2.5rem;
  max-width: 520px;
  backdrop-filter: blur(10px);
  text-align: center;
}

.role-guard-icon {
  margin: 0 auto 1rem auto;
}

.role-guard-title {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
}

.role-guard-description {
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.role-guard-btn {
  display: inline-block;
  background: #00D1C1;
  color: #050C0F;
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
  transition: opacity 0.2s ease;
}

.role-guard-btn:hover {
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/styles/role-guard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd","sourcesContent":[".role-guard-container {\n  min-height: 70vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  textAlign: center;\n}\n\n.role-guard-card {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: 16px;\n  padding: 2.5rem;\n  max-width: 520px;\n  backdrop-filter: blur(10px);\n  text-align: center;\n}\n\n.role-guard-icon {\n  margin: 0 auto 1rem auto;\n}\n\n.role-guard-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #fff;\n  margin-bottom: 8px;\n}\n\n.role-guard-description {\n  color: #94a3b8;\n  font-size: 14px;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.role-guard-btn {\n  display: inline-block;\n  background: #00D1C1;\n  color: #050C0F;\n  padding: 10px 24px;\n  border-radius: 8px;\n  font-weight: 600;\n  text-decoration: none;\n  font-size: 14px;\n  transition: opacity 0.2s ease;\n}\n\n.role-guard-btn:hover {\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
